import { useDispatch, useSelector } from "react-redux"
import { trocaEstados, trocaLivros, trocaSkus } from "./LivrudoSlice"
import React from "react";
import { converterDataParaString, gerarGUID, obterDataAtual } from "./livrudo_helpers";

function Erase() {


    var livros = useSelector((state) => state.livrudo.db.livros)
    var skus = useSelector((state) => state.livrudo.db.skus)
    var estados = useSelector((state) => state.livrudo.db.estados)

    console.log(livros)
    var novos = [livros[0], livros[1], livros[3]]
    console.log(novos)
    // var es = [estados[0], estados[1]]

    // for(var i = 0; i < es.length; i ++) {
    //     if(es[i].sku == "SKU-27508456") {
    //         var n = {...es[i]}
    //         n.sku = "SKU-05587608"
    //         n.id = gerarGUID()
    //         n.data = converterDataParaString(obterDataAtual())
    //         es[i] = n
    //     }
    // }
    // console.log(es)


    var dispatch = useDispatch()
    // var skus = [skus[0]]

    React.useEffect(() => {
        // dispatch(trocaSkus(skus))
        // dispatch(trocaEstados(es))
        dispatch(trocaLivros(novos))
    }, []);

    console.log(estados)

    return "Erase"
}

export default Erase

